module.exports = __webpack_public_path__ + "media/assets/images/logos/gcp_logo-9b4bc4d28474db0a717214afb7eef1ce.png";